// extracted by mini-css-extract-plugin
module.exports = {"direction":"_3S4GG","both":"y9FmZ","left":"_3zoLF","right":"TKNpe"};